/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell\template\cellSort
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "../../base";

@Component
export default class CellSort extends Base {
  private actions = [
    {
      value: "up",
      text: "上移",
      icon: "mdi-arrow-up",
      event: "moveupItem"
    },
    {
      value: "down",
      text: "下移",
      icon: "mdi-arrow-down",
      event: "movedownItem"
    }
  ];

  public get Color() {
    if (this.prop.color) {
      return this.prop.color;
    }
    return "success";
  }

  private get Actions() {
    if (this.index === 0) {
      return [this.actions[1]];
    } else {
      return this.actions;
    }
  }
}
